import { SerpSellingPriceSnapshot } from '@/components/Approval/@components/SerpSellingPrice';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 160 SERP 판매가 조정 — 저장 content 그대로(레거시 조회와 동일), 「상세 보기」 접고 펴기 */
const SerpSellingPriceSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpSellingPriceSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpSellingPriceSlot;
